import { Button, Flex, Text } from '@iziwork/design-system';
import { FC, useState } from 'react';
import styled from 'styled-components';

import { ApplyFormModal } from '~/components';
import { ApplyTypes } from '~/contexts/ApplyFormContext/enums';
import { useTranslation } from '~/hooks';

import { CardItem, CardTitle } from './MissionCard.style';

export const FreeApplicationColumn = styled(Flex.Column)`
  height: 100%;
  justify-content: center;
`;

export const FreeApplicationCard: FC = () => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <CardItem px="l" py="l">
        <FreeApplicationColumn space="l">
          <CardTitle variant="heading-3">{t('free_application_card.title')}</CardTitle>
          <Text variant="body-lighter">{t('free_application_card.message')}</Text>
          <Button
            size="xl"
            onClick={() => {
              setModalOpen(true);
            }}
          >
            {t('free_application_card.button')}
          </Button>
        </FreeApplicationColumn>
      </CardItem>
      {modalOpen && (
        <ApplyFormModal
          applyType={ApplyTypes.free}
          onClose={() => {
            setModalOpen(false);
          }}
        />
      )}
    </>
  );
};
